import { toast } from 'sonner'

import { auth } from '@/api/auth'
import { env } from '@/env'

export const SSO_STATE_KEY = 'sso_state'

export function isSSOEnabled() {
  return env.VITE_SSO_ENABLED
}

type InitiateSSOOptions = {
  onError?: () => void
}

export async function initiateSSOLogin(options?: InitiateSSOOptions) {
  try {
    const state = crypto.randomUUID()
    localStorage.setItem(SSO_STATE_KEY, state)

    const redirectUrl = await auth.getSSORedirectURL(state)
    window.location.href = redirectUrl
  } catch {
    if (options?.onError) {
      options.onError()
    } else {
      toast.error('Gagal menghubungkan ke SSO')
    }
  }
}
